module.exports = __webpack_public_path__ + "img/PAL.5aeb769b.svg";